import React, {useEffect, useState, FC} from "react"
import Fab from "@mui/material/Fab"
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder"
import Grow from "@mui/material/Grow"
import {LightningBoltCircle} from "mdi-material-ui";
import {useRouter} from "next-translate-routes/router";
import {useTranslation} from "next-i18next";
import {useDispatch} from "../../store";
import {useAuth} from "../../hooks/use-auth";
import NextLink from "next-translate-routes/link";
import {setShowAuthWall, setInterestedInTrip} from "../../slices/user-session-slice";
import {useTheme} from "@mui/material/styles";



const icons = [
    "icon-photos",
    "seacrush_heart",
    "icon-conservation",
    "icon-snorkeling-mask",
    "icon-shark",
    "icon-event",
    "icon-aeroplane"
]


interface TripDetailActionsProps {
    tripId: string,
    title: string
}


export const TripDetailActions: FC<TripDetailActionsProps> = ({tripId, title}) => {

    const theme = useTheme()

    const {user, isAuthenticated} = useAuth()

    const router = useRouter()


    // const [navBarOverlayVisible, setNavBarOverlayVisible] = useState(false)

    const [fabVisible, setFabVisible] = useState(false)
    const [drawerOpen, setDrawerOpen] = useState(false)

    const {t} = useTranslation()

    const dispatch = useDispatch();


    useEffect(() => {

        const handleScroll = (e: any) => {
            const body = document.body,
                html = document.documentElement

            const height = Math.max(body.scrollHeight, body.offsetHeight,
                html.clientHeight, html.scrollHeight, html.offsetHeight)

            const scrollTop = Math.max(window.pageYOffset, document.documentElement.scrollTop, document.body.scrollTop)

            // console.log('height', height)

            if (scrollTop < 250 || scrollTop > height - 2300) {
                setFabVisible(false)
            } else {
                setFabVisible(true)
            }

            // if (scrollTop < 600 || scrollTop > height - 2300) {
            //     setNavBarOverlayVisible(false)
            // } else {
            //     setNavBarOverlayVisible(true)
            //
            // }
        }
        window.addEventListener("scroll", handleScroll, {passive: true})

        return () => {

            window.removeEventListener("scroll", handleScroll)

        }

    }, [])

    const handleNavClicked = (destination: string) => {
        //console.log('navClicked')
        setDrawerOpen(false)
        router.push({
            query: router.query,
            pathname: router.pathname,
            hash: `#${destination}`
        })
    }

    const handleTitleClicked = (e: any) => {
        setDrawerOpen(false)

    }


    const isFavorite = user?.interested && user?.interested[tripId];


    return <>
        <Grow in={fabVisible}>
            <div
                style={{
                    zIndex: theme.zIndex.modal - 1,
                    position: "fixed",
                    bottom: theme.spacing(2),
                    width: 200,
                    left: "50%",
                    textAlign: "center",
                    marginLeft: -100
                }}
            >
                {isFavorite ?
                    <NextLink href={{
                        pathname: "/request-booking",
                        query: {
                            tripIdEnc: window.btoa(tripId)
                        }
                    }}
                              passHref
                              legacyBehavior
                    >
                        <Fab variant='extended'
                             color={"secondary"}
                             aria-label='Book Now'
                             component='a'
                            // disabled={!profileLoaded}
                            // style={{
                            //     boxShadow: theme.shadows[23],
                            // }}
                        >
                            <LightningBoltCircle sx={{mr: 1}}/>
                            {t("book-now-button")}
                        </Fab>
                    </NextLink>
                    :
                    <Fab variant='extended'
                         color={"primary"}

                         aria-label='Add to favorites'
                         onClick={async (e) => {
                             if (!isAuthenticated) {
                                 dispatch(setShowAuthWall(true))
                             } else {
                                 if (user) dispatch(setInterestedInTrip(user, tripId))
                             }

                         }
                         }>
                        <FavoriteBorderIcon sx={{mr: 1}}/>
                        {t("i-am-interested")}
                    </Fab>
                }

            </div>
        </Grow>

    </>

}

export default TripDetailActions
